import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessAddresses } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { AddressBulkUploadPage } from "./pages/AddressBulkUploadPage";
import { AddressListPage } from "./pages/AddressListPage";
import { CreateAddressPage } from "./pages/CreateAddressPage";
import { EditAddressPage } from "./pages/EditAddressPage";
import { canEditAddresses, canManageAddresses } from "./permissions";
import { addressRoutes } from "./routes";

export const addressesRoute = [
  {
    path: addressRoutes.list,
    element: (
      <RequireAuth permission={canAccessAddresses}>
        <AddressListPage />
      </RequireAuth>
    ),
  },
  {
    path: addressRoutes.new,
    element: (
      <RequireAuth permission={canManageAddresses}>
        <CreateAddressPage />
      </RequireAuth>
    ),
  },
  {
    path: addressRoutes.edit,
    element: (
      <RequireAuth permission={canEditAddresses}>
        <EditAddressPage />
      </RequireAuth>
    ),
  },
  {
    path: addressRoutes.bulkUpload,
    element: (
      <RequireAuth permission={canManageAddresses}>
        <AddressBulkUploadPage />
      </RequireAuth>
    ),
  },
  {
    path: "*",
    element: <ErrorPage status={404} />,
  },
] satisfies RouteObject[];
